// General Report Statuses
export const REPORT_STATUS = {
  OK: 'ok',
  NOT_SETUP: 'not_setup',
  FIRST_RUNNING: 'first_running',
  RUNNING: 'running',
  FAILED: 'failed',
  FIRST_RUN_FAILED: 'first_run_failed',
  NEVER_RUN: 'never_run',
  GET_STARTED: 'get_started'
} as const;

// Report Schedule
export const REPORT_SCHEDULE = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly',
  ADHOC: 'adhoc'
} as const;

/** Monthly `run_on` value that runs a report on the last day of each month. */
export const REPORT_SCHEDULE_LAST_DAY_OF_MONTH = -1;
